import React from 'react';
import { shallowEqual, useSelector } from 'react-redux';
import { Modal } from 'react-responsive-modal';
import './index.scss';

const ModalName = 'ModalMessage';

const Message = ({ name, toggleModal, displayClose, msg, isError }) => {
	const closeModal = () => toggleModal(ModalName);
	const localize = useSelector((state) => state.localize.event, shallowEqual);
	return (
		<Modal
			open={name[ModalName]}
			classNames={{
				modal: `modal modal-message`,
				overlay: 'overlay',
				closeButton: 'close-button',
				closeIcon: 'close-icon',
				modalAnimationIn: 'slideInUp',
				modalAnimationOut: 'slideOutDown',
			}}
			animationDuration={250}
			center
			focusTrapped={false}
			onClose={closeModal}
			blockScroll={false}
			showCloseIcon={displayClose}
			closeOnOverlayClick={displayClose}
			closeOnEsc={displayClose}
		>
			<div className="modal-title">
				<h3>
					{isError ? localize?.txt_error_title : localize?.txt_congrats_title}
				</h3>
			</div>
			<div className="modal-content">
				<p className="text">{localize[msg] ?? msg}</p>
			</div>
		</Modal>
	);
};

export default Message;
